"use client";

import React, { useEffect } from "react";

import { initClientTelemetry } from "./otel-client";

export interface TelemetryProviderProps {
  serviceName: string;
  otlpEndpoint?: string;
  propagateTraceHeaderCorsUrls?: string[];
  children: React.ReactNode;
}

export function TelemetryProvider({
  serviceName,
  otlpEndpoint = process.env.NEXT_PUBLIC_OTEL_EXPORTER_OTLP_ENDPOINT,
  propagateTraceHeaderCorsUrls,
  children,
}: TelemetryProviderProps) {
  useEffect(() => {
    initClientTelemetry({
      serviceName,
      otlpEndpoint: otlpEndpoint || process.env.NEXT_PUBLIC_OTEL_EXPORTER_OTLP_ENDPOINT,
      propagateTraceHeaderCorsUrls: propagateTraceHeaderCorsUrls?.map((url) =>
        url.startsWith("/") ? new RegExp(url) : url,
      ),
    });
  }, [serviceName, otlpEndpoint, propagateTraceHeaderCorsUrls]);

  return <>{children}</>;
}
